/* eslint-disable camelcase */

import React, { createContext } from 'react';
import PropTypes from 'prop-types';

import service from './service';

const AttachmentContext = createContext([]);

const AttachmentProvider = ({ children }) => (
  <AttachmentContext.Provider
    value={{
      actions: service,
    }}
  >
    {children}
  </AttachmentContext.Provider>
);

AttachmentProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export {
  AttachmentContext,
  AttachmentProvider,
};

